import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getCurrentMeetings, getPastMeetings, createMeeting } from 'actions/meetings';
import CreateMeeting from 'containers/Meeting/Form/CreateMeeting';
import Modal from 'containers/Modals/Modal';
import React, { Component } from 'react';
import moment from 'moment';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { setPageTitle, setPageActions } from 'actions/header';
import { Block, Flex, Tabs, Tab } from '@haldor/ui';
import { Spinner } from 'UI';
import User from '_class/User';
import { withRouter, Link } from 'react-router-dom';

var MyMeetings = /*#__PURE__*/function (_Component) {
  _inherits(MyMeetings, _Component);

  var _super = _createSuper(MyMeetings);

  /* Class setup */
  function MyMeetings(props) {
    var _this;

    _classCallCheck(this, MyMeetings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.user);
      var actions = [];

      if (user.isMentor()) {
        actions.push({
          type: 'button',
          value: _this.props.translate('new-meeting'),
          buttonType: 'primary',
          onClick: _this.toggleModal,
          icon: 'plus'
        });
      }

      _this.props.setPageTitle(_this.props.translate('meetings'));

      _this.props.setPageActions(actions);

      _this.props.getCurrentMeetings().then(function () {
        _this.setState({
          loadingCurrent: false
        });
      });

      _this.onTabsChange();
    });

    _defineProperty(_assertThisInitialized(_this), "onTabsChange", function () {
      if (window.location.hash != '#past') {
        return false;
      }

      if (!_this.state.loadingPast && _this.props.past.length == 0) {
        _this.setState({
          loadingPast: true
        });

        _this.props.getPastMeetings().then(function () {
          _this.setState({
            loadingPast: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.props.history.push('/meetings/wizard');
    });

    _defineProperty(_assertThisInitialized(_this), "onMeetingSubmit", function (meeting) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.props.createMeeting(meeting);

                case 2:
                  _context.next = 4;
                  return _this.props.getCurrentMeetings();

                case 4:
                  _this.toggleModal();

                  resolve(1);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "renderMeetingProgress", function (meeting) {
      var width = 0;

      if (meeting.totalMeetings != 0 && meeting.meetingsCompleted != 0) {
        width = meeting.meetingsCompleted / meeting.totalMeetings * 100;
      }

      return meeting.totalMeetings != null && meeting.meetingsCompleted != null ? /*#__PURE__*/React.createElement("div", {
        className: "size-14 color--meta"
      }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, _this.props.translate('completed-meeting')), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          textAlign: 'right'
        }
      }, meeting.meetingsCompleted, " / ", meeting.totalMeetings)), /*#__PURE__*/React.createElement("div", {
        className: "meeting-progress-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "indicator",
        style: {
          width: "".concat(width, "%")
        }
      }))) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMeetingCard", function (meeting) {
      var translate = _this.props.translate;
      var user = new User(_this.props.user);
      return /*#__PURE__*/React.createElement(Link, {
        to: "/meeting/".concat(meeting.id),
        key: meeting.id
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, meeting.title, moment().diff(moment(meeting.created), 'days') <= 2 ? /*#__PURE__*/React.createElement("span", {
        className: "new-badge",
        style: {
          marginLeft: '.5rem'
        }
      }, translate('new')) : null, meeting.status === 'DRAFT' ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.5rem'
        },
        className: "new-badge"
      }, translate('Draft')) : null, /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.5rem'
        },
        className: "new-badge"
      }, meeting.creator == _this.props.user.id ? _this.props.translate('organizer') : _this.props.translate('participant'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), meeting.creator == _this.props.user.id || user.isMentor() ? /*#__PURE__*/React.createElement("div", null, _this.renderMeetingProgress(meeting)) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentMeetingCard", function (meeting) {
      if (meeting == null || meeting.instances == null || meeting.instances.length == 0) {
        return null;
      }

      var instance = meeting.instances[0];
      return /*#__PURE__*/React.createElement(Link, {
        key: meeting.id,
        to: "/meeting/".concat(meeting.id, "/instance/").concat(instance.id)
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, meeting.title)));
    });

    _this.state = {
      loadingCurrent: true,
      loadingPast: false,
      modal: false
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(MyMeetings, [{
    key: "render",
    value:
    /* Render methods */
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          current = _this$props.current,
          past = _this$props.past;
      var user = new User(this.props.user);
      return /*#__PURE__*/React.createElement("div", {
        className: "meeting"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        onClose: this.toggleModal,
        title: this.props.translate('new-meeting')
      }, /*#__PURE__*/React.createElement(CreateMeeting, {
        onSubmit: this.onMeetingSubmit,
        onAbort: this.toggleModal
      })), /*#__PURE__*/React.createElement(Tabs, {
        onChange: this.onTabsChange
      }, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('current-meetings'),
        route: "current"
      }, this.state.loadingCurrent && current.length == 0 ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, current.map(function (meeting) {
        if (user.isStudent()) {
          return _this2.renderStudentMeetingCard(meeting);
        }

        return _this2.renderMeetingCard(meeting);
      })), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('past-meetings'),
        route: "past"
      }, this.state.loadingPast && past.length == 0 ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, past.map(function (meeting) {
        if (user.isStudent()) {
          return _this2.renderStudentMeetingCard(meeting);
        }

        return _this2.renderMeetingCard(meeting);
      }))));
    }
  }]);

  return MyMeetings;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    created: state.Meetings.meetingsByCreator,
    current: state.Meetings.current,
    past: state.Meetings.past
  };
}

export default withRouter(connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  createMeeting: createMeeting,
  getCurrentMeetings: getCurrentMeetings,
  getPastMeetings: getPastMeetings
})(MyMeetings));